const IconSpaces = () => {
    return (
        <svg
            width="27"
            height="33"
            viewBox="0 0 27 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M26.1502 28.6937H22.0558V3.2001H18.8112V1.65503C18.8112 1.42327 18.6953 1.19151 18.5408 1.07563C18.3476 0.921126 18.1159 0.882502 17.9227 0.921128L5.13733 3.23872C4.75107 3.31598 4.51931 3.62499 4.51931 4.01126V28.7323H0.772532C0.34764 28.7323 0 29.0799 0 29.5048C0 29.9297 0.34764 30.2774 0.772532 30.2774H7.80257C7.8412 30.2774 7.91845 30.2774 7.95707 30.2774L17.9614 32.0928C18 32.0928 18.0386 32.0928 18.1159 32.0928C18.309 32.0928 18.4635 32.0156 18.618 31.8997C18.8112 31.7452 18.8884 31.552 18.8884 31.3203V30.2774H21.3605H22.133H26.2275C26.6524 30.2774 27 29.9297 27 29.5048C27 29.0799 26.5751 28.6937 26.1502 28.6937ZM17.2661 30.3546L6.02574 28.3074V4.62929L17.2661 2.58208V30.3546ZM20.5107 28.6937H18.8112V4.74516H20.5107V28.6937ZM15.2575 18.1486C15.6438 18.1486 15.9528 17.6465 15.9528 17.0284C15.9528 16.4104 15.6438 15.9083 15.2575 15.9083C14.8712 15.9083 14.5622 16.4104 14.5622 17.0284C14.5622 17.6465 14.8712 18.1486 15.2575 18.1486Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default IconSpaces;
